import { resolveWidgetLocale, type WidgetLocale } from "@shared/widgets/localeResolver";
import type { WidgetI18nMessages } from "@shared/widgets/i18nKeys";
import frMessages from "./fr.json";
import enMessages from "./en.json";

const MESSAGES: Record<WidgetLocale, WidgetI18nMessages> = {
  fr: frMessages as WidgetI18nMessages,
  en: enMessages as WidgetI18nMessages,
};

export const resolveLocaleFromNavigator = (input: string | null | undefined): WidgetLocale =>
  resolveWidgetLocale(input);

export type Translator = (
  key: keyof WidgetI18nMessages,
  params?: Record<string, string | number>,
) => string;

const interpolate = (template: string, params: Record<string, string | number>): string =>
  template.replace(/\{(\w+)\}/g, (match, name: string) => {
    if (Object.prototype.hasOwnProperty.call(params, name)) {
      return String(params[name]);
    }
    return match;
  });

export const createTranslator = (locale: WidgetLocale): Translator => {
  const messages = MESSAGES[locale];
  return (key, params) => {
    const template = messages[key];
    if (!params) return template;
    return interpolate(template, params);
  };
};

export type { WidgetLocale };
